import serviceRequest from "utils/request";

const baseUrl = "/api/resource";

export const privateFileList = (params) => {
	return serviceRequest({
		url: `${baseUrl}/file/private/list`,
		method: "get",
		params,
	});
};

export const publicFileList = (params = {}) => {
	return serviceRequest({
		url: `${baseUrl}/file/list`,
		method: "post",
		data: params,
	});
};

export const publicFileUpload = (params, data) => {
	return serviceRequest({
		url: `${baseUrl}/file/upload`,
		method: "post",
		params,
		data,
	});
};

export const publicFileDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/file/detail`,
		method: "post",
		data: params,
	});
};

export const publicFileDelete = (params) => {
	return serviceRequest({
		url: `${baseUrl}/file/delete`,
		method: "post",
		data: params,
	});
};

export const downloadPrivateFile = (uniqueId, fileName) => {
	return serviceRequest({
		url: `${baseUrl}/file/download/${uniqueId}/${fileName}`,
		method: "get",
		responseType: "blob",
	});
};
